export default __webpack_public_path__ + "static/media/IconOffice.8213e94d.svg";